import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ChatbotNavbar } from '../components/Shared/ChatbotNavbar';
import { ChatbotSidebar } from '../components/Shared/ChatbotSidebar';
import { ChatbotProvidersPage } from '../pages/ChatbotAdmin/ProvidersPage';
import ChatbotWorkspacesPage from '../pages/ChatbotAdmin/WorkspacesPage';
import { ChatbotUsersPage } from '../pages/ChatbotAdmin/UsersPage';
import { ChatbotAnalyticsPage } from '../pages/ChatbotAdmin/AnalyticsPage';
import { ChatbotDocumentsPage } from '../pages/ChatbotAdmin/DocumentsPage';
import { WorkspaceEditPage } from '../pages/ChatbotAdmin/WorkspaceEditPage';
// VirtualAssistantPage removido - funcionalidade obsoleta

const ChatbotLayout: React.FC = () => {
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  // Se a rota atual não for uma das rotas válidas, redireciona para analytics
  const isInvalidRoute = ![
    '/chatbot-admin/providers',
    '/chatbot-admin/workspaces',
    '/chatbot-admin/workspaces/edit',
    '/chatbot-admin/users',
    '/chatbot-admin/analytics',
    '/chatbot-admin/documents',
    '/chatbot-admin/virtual-assistant'
  ].some(route => location.pathname.startsWith(route));

  if (isInvalidRoute && location.pathname !== '/chatbot-admin') {
    return <Navigate to="/chatbot-admin/analytics" replace />;
  }

  return (
    <div className="h-dvh overflow-hidden flex flex-col bg-gray-50">
      <ChatbotNavbar onOpenMobileNav={() => setMobileNavOpen(true)} />
      <div className="flex flex-1 min-h-0 overflow-hidden">
        <ChatbotSidebar
          mobileOpen={mobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
        />
        <main className="flex-1 min-h-0 overflow-y-auto p-4 md:p-6">
          <Routes>
            <Route path="/" element={<Navigate to="/chatbot-admin/analytics" replace />} />
            <Route path="/providers" element={<ChatbotProvidersPage />} />
            <Route path="/workspaces" element={<ChatbotWorkspacesPage />} />
            <Route path="/workspaces/edit" element={<WorkspaceEditPage />} />
            <Route path="/users" element={<ChatbotUsersPage />} />
            <Route path="/analytics" element={<ChatbotAnalyticsPage />} />
            <Route path="/documents" element={<ChatbotDocumentsPage />} />
            {/* VirtualAssistantPage removido - funcionalidade obsoleta */}
            <Route path="*" element={<Navigate to="/chatbot-admin/analytics" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default ChatbotLayout;
